import { Alert, Box } from "@mui/material";
import { FC } from "react";

type NoDataAlertProps = {
  message?: string
}

const NoDataAlert: FC<NoDataAlertProps> = ({message = "Sem registros para os filtros aplicados"}): JSX.Element => {
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Alert
        severity="info" sx={{
          maxWidth: "50%",
          margin: "auto",
        }}
      >
        {message}
      </Alert>
    </Box>
  )
}

export default NoDataAlert;
